var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cases-listing-table"},[_c('BaseTableReportHistoryTable',{ref:"usedHistoryTableRef",attrs:{"tableData":_vm.tableData},on:{"filter_submit":function($event){return _vm.filterSubmit($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }